var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", [
    _c(
      "label",
      {
        staticClass: "btn btn-default btn-sm input-group-btn__icon btn-sm__file"
      },
      [
        _c("span", { staticClass: "fa fa-cloud-upload fa-lg p-0" }),
        _vm._v(" "),
        _c("input", {
          ref: "fileupload",
          attrs: { type: "file", accept: _vm.accept },
          on: { change: _vm.fileUpload }
        })
      ]
    ),
    _vm._v(" "),
    _vm.showFileName
      ? _c("span", { staticClass: "m-l-10" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.fileName && _vm.fileName !== ""
                  ? _vm.fileName
                  : _vm.$t("INPUT_NO_FILE")
              ) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }